import { render } from "./FileViewerBreadcrumbs.vue?vue&type=template&id=366c8cdb&scoped=true&ts=true"
import script from "./FileViewerBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./FileViewerBreadcrumbs.vue?vue&type=script&lang=ts"

import "./FileViewerBreadcrumbs.vue?vue&type=style&index=0&id=366c8cdb&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366c8cdb"]])

export default __exports__